import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable, of } from 'rxjs'
import { map } from 'rxjs/operators'
import { environment } from '../../../environments/environment'
import { JSONRpc } from '../service-jsonrpc'


//import moment = require('moment')

import * as moment from 'moment'

@Injectable({
	providedIn: 'root',
})
export class AppService {

	BASE_URL = 'assets/strings/';
	cacheListStatusDossier: any[]
	cacheListStateDossier: any[]
	cacheListZoneDossier: any[]
	cacheListTypeInstru: any[]
	cacheListEtatInstru: any[]

	constructor(private http: HttpClient) { }

	getConnectToken(): Observable<any> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.connection:getToken',
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	connect(login: string, pass: string): Observable<any> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.connection:connect',
			params: {
				login: login,
				password: pass,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	send401(): Observable<any> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.connection:send401',
			params: {},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	connectLdap(): Observable<any> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.connection:connectldap',
			params: {},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	sendValidationUser(id, email): Observable<any> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.dossier:emailvalidsend',
			params: {
				id: id,
				email: email,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	sendPassword(id): Observable<any> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.dossier:password',
			params: {
				id: id,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	getFormulaire(
		_type: string,
		parent?: any,
		instructionid?: any
	): Observable<any> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.formulaire:new',
			params: {
				type: _type,
				options: {
					parent: parent,
				},
			},
		})

		if (instructionid) rpcMethod.params.options.instruction = instructionid

		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	setNewFormulaire(
		_type: string,
		_fields: any,
		instructionid?: any,
		parentid?: any
	): Observable<any> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.formulaire:set',
			params: {
				type: _type,
				id: 0,
				options: {
					fields: _fields,
				},
			},
		})
		if (instructionid) rpcMethod.params.options.instruction = instructionid
		if (parentid) rpcMethod.params.options.parent = parentid
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	setFormulaires(arrayId: any, instruction: any): Observable<any> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.formulaire:init',
			params: {
				types: arrayId,
				options: {
					instruction: instruction.ID,
					demande: instruction.demande.ID,
				},
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	printFormulaire(
		id: any,
		nonull?: boolean,
		wide?: boolean
	): Observable<any> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.impression:print',
			params: {
				id: id,
				options: {},
			},
		})
		if (nonull) rpcMethod.params.options.nonull = nonull
		if (wide) rpcMethod.params.options.wide = wide

		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	getNewInstruction(_type: string, options?: any): Observable<any> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.instruction:new',
			params: {
				type: _type,
				options: options,
			},
		})

		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	createNewInstruction(
		_type: string,
		_dossierid: any,
		instruction: any,
		options?: any
	): Observable<any> {
		let demande = instruction.demande
		demande.etat = demande.etat.id
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.instruction:set',
			params: {
				type: _type,
				id: 0,
				options: {
					demande: demande,
					dossier: _dossierid,
					debut: instruction.debutdate,
					instructeur: instruction.instructeur,
					transition: instruction.transistions,
				},
			},
		})

		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	setInstruction(instruction: any): Observable<any> {
		instruction.demande = {
			id: instruction.demande.ID,
			type: instruction.demande.demandeType
				? instruction.demande.demandeType
				: instruction.demande.type.ID,
		}
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.instruction:set',
			params: {
				type: instruction.type.key,
				id: instruction.ID,
				options: {
					parameters: {},
				},
			},
		})

		if (instruction.instructeurid)
			rpcMethod.params.options.instructeur = instruction.instructeurid

		if (instruction.comment)
			rpcMethod.params.options.comment = instruction.comment

		if (instruction.titre)
			rpcMethod.params.options.titre = instruction.titre
			
		if (instruction.debut)
			rpcMethod.params.options.debut = instruction.debut

		if (instruction.demande)
			rpcMethod.params.options.parameters.demande = instruction.demande

		if (instruction.findatedossier || instruction.droit) {
			rpcMethod.params.options.parameters.dossier = {
				findate: instruction.findatedossier
					? instruction.findatedossier
					: '',
				etat: instruction.droit ? instruction.droit : '',
			}
		}

		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	setTransitionInstruction(instruction: any): Observable<any> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.instruction:set',
			params: {
				type: instruction.type.key,
				id: instruction.ID,
				options: {
					transition: instruction.transitionid,
					instructeur: instruction.instructeurid,
					comment: instruction.comment,
				},
			},
		})

		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	setFormulaire(
		form: any,
		instruction: any,
		demandeformulaireid?: any,
		etat?: any,
		parent?: any
	): Observable<any> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.formulaire:set',
			params: {
				type: form.key,
				id: demandeformulaireid ? demandeformulaireid : 0,
				options: {
					fields: form.fields,
					instruction: instruction.ID,
					demande: instruction.demande.ID,
					etat: etat ? Number(etat) : 1,
				},
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	setFormulaireEtat(
		demandeformulaireid: number,
		etat: number
	): Observable<any> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.formulaire:setetat',
			params: {
				id: demandeformulaireid,
				etat: etat,
				options: {},
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	setFormulaireDelete(demandeformulaireid: number): Observable<any> {
		return this.setFormulaireEtat(demandeformulaireid, -1)
	}

	setFormulaireRestore(demandeformulaireid: number): Observable<any> {
		return this.setFormulaireEtat(demandeformulaireid, 0)
	}

	getFormulairesForDemande(
		demandeid: any,
		_nodata?: boolean
	): Observable<any> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.formulaire:demandes',
			params: {
				options: {
					demande: demandeid,
					noValue: _nodata,
				},
			},
		})

		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	getFormulaireByID(formulaireID: any, formType?: any): Observable<any> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.formulaire:get',
			params: {
				id: formulaireID,
				options: {
					type: formType,
				},
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	getListDocumentsForInstruction(instructionid: any): Observable<any> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.document:list',
			params: {
				options: {
					instruction: instructionid,
				},
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	lockFormulaire(formid: any): Observable<any> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.formulaire:lock',
			params: {
				id: formid,
				etat: 1,
				options: {},
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	unlockFormulaire(formid: any): Observable<any> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.formulaire:lock',
			params: {
				id: formid,
				etat: 0,
				options: {},
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	getUsersByProfressions(
		professions: any,
		_dossierid?: string,
		search?: any
	): Observable<any> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.tiers:listbyprofessions',
			params: {
				professions: professions,
				options: {
					sort: {},
				},
			},
		})
		if (search) rpcMethod.params.options.search = search

		if (_dossierid) rpcMethod.params.options.sort.dossier = _dossierid

		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	getDemande(
		_typeDemande: string,
		_typeForm?: any,
		_dossierid?: string
	): Observable<any> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.demande:new',
			params: {
				type: _typeDemande,
				options: {
					form: _typeForm,
				},
			},
		})
		if (_dossierid) rpcMethod.params.options.dossier = _dossierid

		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	getForm(_typeForm: any, _dossierid?: string): Observable<any> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.formulaire:new',
			params: {
				type: _typeForm,
				options: {},
			},
		})
		if (_dossierid) rpcMethod.params.options.dossier = _dossierid

		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	getExistingDemande(_id: string, _typeForm?: any): Observable<any> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.demande:get',
			params: {
				id: _id,
				options: {
					form: _typeForm,
				},
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	setDemande(
		_typeform: string,
		_typedemande: string,
		_demande: any,
		_noworkflow: any
	): Observable<any> {
		_demande.code = _typeform
		if (_demande.dossier) _demande.dossier = _demande.dossier.ID
		if (_noworkflow) _demande.noworkflow = _noworkflow
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.demande:set',
			params: {
				type: _typedemande,
				parameters: _demande,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	changeEtatDemande(idDemande: string, idTransition: string): Promise<any> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.workflow:set',
			params: {
				id: idDemande,
				transition: idTransition,
			},
		})
		return this.http
			.post<JSONRpc>(environment.webservice, rpcMethod)
			.toPromise()
	}

	getDossier(_id: string): Observable<any> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.dossier:get',
			params: {
				id: _id,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	getDossierList(): Observable<any> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.dossier:getList',
			params: {},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	getDossierFormulaireList(_id: string, _options: any = []): Observable<any> {
		let json = {
			jsonrpc: '2.0',
			method: 'webservice.dossier:getformulairelist',
			params: {
				id: _id,
				options: _options,
			},
		}

		let rpcMethod = new JSONRpc(json)
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	getDossierDocumentList(_id: string, _options: any = []): Observable<any> {
		let json = {
			jsonrpc: '2.0',
			method: 'webservice.dossier:getDocumentList',
			params: {
				id: _id,
				options: _options,
			},
		}
		let rpcMethod = new JSONRpc(json)
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	getDossierInsctructionList(_id: string): Observable<any> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.dossier:getinstructionlist',
			params: {
				id: _id,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	getList(_id: string, _options: any, _nodata?: boolean): Observable<any> {
		let json = {
			jsonrpc: '2.0',
			method: 'webservice.liste:get',

			params: {
				id: _id,
				options: _options,
			},
		}

		if (_nodata) {
			json['params']['options'] = {
				nodata: _nodata,
			}
		}
		let rpcMethod = new JSONRpc(json)

		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	getStatutDossierList(): Observable<any> {
		if (
			!this.cacheListStatusDossier ||
			this.cacheListStatusDossier.length === 0
		) {
			let rpcMethod = new JSONRpc({
				jsonrpc: '2.0',
				method: 'webservice.parametre:statut',
				params: {},
			})
			return this.http
				.post<JSONRpc>(environment.webservice, rpcMethod)
				.pipe(
					map((result: any) => {
						this.cacheListStatusDossier = result.result
						return result
					})
				)
		} else
			return of({
				result: this.cacheListStatusDossier,
			})
	}
	getStateDossierList(): Observable<any> {
		if (
			!this.cacheListStateDossier ||
			this.cacheListStateDossier.length == 0
		) {
			let rpcMethod = new JSONRpc({
				jsonrpc: '2.0',
				method: 'webservice.parametre:state',
				params: {},
			})
			return this.http
				.post<JSONRpc>(environment.webservice, rpcMethod)
				.pipe(
					map((result: any) => {
						this.cacheListStateDossier = result.result
						return result
					})
				)
		} else
			return of({
				result: this.cacheListStateDossier,
			})
	}
	getZoneDossierList(): Observable<any> {
		if (
			!this.cacheListZoneDossier ||
			this.cacheListZoneDossier.length == 0
		) {
			let rpcMethod = new JSONRpc({
				jsonrpc: '2.0',
				method: 'webservice.parametre:zones',
				params: {},
			})
			return this.http
				.post<JSONRpc>(environment.webservice, rpcMethod)
				.pipe(
					map((result: any) => {
						this.cacheListZoneDossier = result.result
						return result
					})
				)
		} else
			return of({
				result: this.cacheListZoneDossier,
			})
	}

	getTypeInstruction(): Observable<any> {
		if (!this.cacheListTypeInstru || this.cacheListTypeInstru.length == 0) {
			let rpcMethod = new JSONRpc({
				jsonrpc: '2.0',
				method: 'webservice.parametre:instruction',
				params: {},
			})
			return this.http
				.post<JSONRpc>(environment.webservice, rpcMethod)
				.pipe(
					map((result: any) => {
						this.cacheListTypeInstru = result.result
						return result
					})
				)
		} else
			return of({
				result: this.cacheListTypeInstru,
			})
	}

	getEtatInstruction(): Observable<any> {
		if (!this.cacheListEtatInstru || this.cacheListEtatInstru.length == 0) {
			let rpcMethod = new JSONRpc({
				jsonrpc: '2.0',
				method: 'webservice.parametre:instructionstatut',
				params: {},
			})
			return this.http
				.post<JSONRpc>(environment.webservice, rpcMethod)
				.pipe(
					map((result: any) => {
						this.cacheListEtatInstru = result.result
						return result
					})
				)
		} else
			return of({
				result: this.cacheListEtatInstru,
			})
	}

	getTypeList(): Observable<any> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.parametre:type',
			params: {},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	getArchiveList(): Observable<any> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.parametre:archive',
			params: {
				options: [],
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	getDroitsApplication(): Observable<any> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.application:get',
			params: {
				type: 'GESTMAT',
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	setNotification(idNotification: string, actions: any): Observable<any> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.notification:set',
			params: {
				id: idNotification,
				actions: actions,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	getAllNotifications(): Observable<any> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.notification:get',
			params: {},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	getVilles(ville: string): Observable<any> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.adresse:villes',
			params: {
				ville: ville.toUpperCase(),
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	getCodePostal(zip: string): Observable<any> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.adresse:codepostal',
			params: {
				zip: zip,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	getVillesByCP(zip: string): Observable<any> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.adresse:villebycp',
			params: {
				zip: zip,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	getVilleByID(id: string): Observable<any> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.adresse:villebyid',
			params: {
				id: id,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	getRues(rue: string, villeid: string): Observable<any> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.adresse:rues',
			params: {
				libelle: rue.toUpperCase(),
				villeid: villeid,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	getRueByVille(villeid: string): Observable<any> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.adresse:ruebyville',
			params: {
				villeid: String(villeid),
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	getZone(villeid: string, numrue: string, rueid: string): Observable<any> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.adresse:zones',
			params: {
				villeid: villeid,
				options: {
					numero: numrue,
					rueid: rueid,
				},
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	getImpression(
		idDemande: string,
		codeForm: string,
		formId: string
	): Promise<any> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.demande:print',
			params: {
				id: idDemande,
				options: {
					form: codeForm,
					formid: formId,
				},
			},
		})
		return this.http
			.post<JSONRpc>(environment.webservice, rpcMethod)
			.toPromise()
	}

	getListCourrier(demande: any): Observable<any> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.courrier:list',
			params: {
				options: {
					demande: demande.ID,
				},
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	getHtmlCourrier(
		demandecourrier: any,
		demande: any,
		libres: any,
		destinataire: any
	): Observable<any> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.courrier:html',
			params: {
				id: demandecourrier.ID,
				options: {
					demande: demande.ID,
					courrier: demandecourrier.key,
					destination: destinataire,
					libres: libres,
				},
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	generateCourriers(courriers, instructionID): Observable<any> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.courrier:init',
			params: {
				types: courriers,

				options: {
					instruction: instructionID,
				},
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	getCourrier(
		demandecourrier: any,
		demande: any,
		format: string,
		iddemandecourrier?: string,
		libres?: any,
		destinataire?: any
	): Promise<any> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.courrier:get',
			params: {
				id: iddemandecourrier ? iddemandecourrier : '0',
				options: {
					demande: demande.ID,
					courrier: demandecourrier.key,
					html: demandecourrier.html,
					format: format,
					libres: libres,
					destination: destinataire,
				},
			},
		})
		return this.http
			.post<JSONRpc>(environment.webservice, rpcMethod)
			.toPromise()
	}
	setCourrierEtat(demandecourrierid: number, etat: number): Observable<any> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.courrier:etat',
			params: {
				id: demandecourrierid,
				etat: etat,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	setCourrierDelete(demandecourrierid: number): Observable<any> {
		return this.setCourrierEtat(demandecourrierid, 0)
	}

	setCourrierRestore(demandecourrierid: number): Observable<any> {
		return this.setCourrierEtat(demandecourrierid, 1)
	}

	signCourrier(demandecourrierid: number): Observable<any> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.courrier:sign',
			params: {
				id: demandecourrierid,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	unsignCourrier(demandecourrierid: number): Observable<any> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.courrier:sign',
			params: {
				id: demandecourrierid,
				options: {
					unsign: true,
				},
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	getParamsCourrier(): Observable<any> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.parametre:courrier',
			params: {},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	getTypeSuivis(): Observable<any> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.parametre:suivi',
			params: {},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	newSuivi(suivi: any): Promise<any> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.suivi:set',
			params: {
				dossierid: suivi.idDossier,
				code: suivi.type,
				label: suivi.libelle,
				description: suivi.description,
				options: {
					file: suivi.file,
					datedebut: moment(suivi.date).format('YYYY-MM-DD'),
				},
			},
		})
		return this.http
			.post<JSONRpc>(environment.webservice, rpcMethod)
			.toPromise()
	}

	newBulletin(bulletin: any): Promise<any> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.fichier:set',
			params: {
				dossierid: bulletin.idDossier,
				code: bulletin.type,
				file: bulletin.file,
				options: {
					label: bulletin.libelle,
					datedebut: moment(bulletin.date).format('YYYY-MM-DD'),
				},
			},
		})
		return this.http
			.post<JSONRpc>(environment.webservice, rpcMethod)
			.toPromise()
	}
	getFilters(id: string, _nodata: boolean = true): Promise<any> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.liste:get',
			params: {
				id: id,
				nodata: _nodata
			},
		})
		return this.http
			.post<JSONRpc>(environment.webservice, rpcMethod)
			.toPromise()
	}
	saveFilters(id: string, label: string, filters: any): Promise<any> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.liste:setfilter',
			params: {
				id: id,
				libelle: label,
				filters: filters,
			},
		})
		return this.http
			.post<JSONRpc>(environment.webservice, rpcMethod)
			.toPromise()
	}

	removeFilter(id: string): Promise<any> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.liste:removefilter',
			params: {
				id: id,
			},
		})
		return this.http
			.post<JSONRpc>(environment.webservice, rpcMethod)
			.toPromise()
	}

	archivateDossier(id: string, state: number = 1): Observable<any> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.dossier:archive',
			params: {
				id: id,
				state: state,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	getNotifications(options: any): Observable<any> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.accueil:notifications',
			params: {
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	getListsDashboard(options: any): Observable<any> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.accueil:list',
			params: {
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	notifSeen(id: any): Observable<any> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.notification:set',
			params: {
				id: id,
				actions: ['read', 'done'],
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	getListeTierSelection(search: string): Observable<any> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.tiers:list',
			params: {
				types: ['ADMIN', 'PMI'],
				options: {
					search: search,
				},
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	getTierByID(id: string): Observable<any> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.tiers:searchbyid',
			params: {
				id: id,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	getDoublons(id: string): Observable<any> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.tiers:doublon',
			params: {
				id: id,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	dedoublonner(from: string, to: string): Observable<any> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.tiers:duplicate',
			params: {
				idfrom: from,
				idto: to,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	changeTypeTier(id: string, type: string): Observable<any> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.tiers:changetype',
			params: {
				id: id,
				type,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	signInstruction(id: string): Observable<any> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.instruction:sign',
			params: {
				id: id,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	unsignInstruction(id: string): Observable<any> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.instruction:sign',
			params: {
				id: id,
				options: {
					unsign: true,
				},
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	cancelInstruction(id: string): Observable<any> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.instruction:annuler',
			params: {
				id: id,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	synthese(dossierId: string): Observable<any> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.impression:synthese',
			params: {
				id: dossierId,
				options: {},
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	tagsTypes(tiersID: string): Observable<any> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.tagTiers:getTiersTags',
			params: {
				tiers_id: tiersID,
				options: {},
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	addTagToTiers(tag_code: string, tiers_id: string): Observable<any> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.tagTiers:addTagToTiers',
			params: {
				tag_code: tag_code,
				tiers_id: tiers_id,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	removeTagFromTiers(tag_id: string, tiers_id: string) {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.tagTiers:removeTagFromTiers',
			params: {
				tag_id: tag_id,
				tiers_id: tiers_id,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	canAddNewTags(tiers_id: string) {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.tagTiers:thisTypeHasActiveTags',
			params: {
				tiers_id: tiers_id,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	tierAccess(tiers_id: string): Observable<any> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.instruction:tierAccess',
			params: {
				tiers_id: tiers_id,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	getTriggers(options: any[] = []): Observable<any> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.liste:getTriggers',
			params: {
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	getTiersType(): Observable<any> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.tiers:getTiersType',
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	getConsultationList(options: any[] = []): Observable<any> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.liste:getConsultationList',
			params: {
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	getPageList(_options: any = []): Observable<any> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.page:list',
			params: {
				options: _options,
			},
		})

		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	getPageAction(id: string, _options: any = []): Observable<any> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.page:getPageAction',
			params: {
				id: id,
				options: _options,
			},
		})

		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	json_strings(page_code: string) {
		return this.http.get('./assets/strings/' + page_code + '.json')
	}
	getString(path: string) {
		return this.http.get(`${this.BASE_URL}${path}.json`)
	}
}
